export default {
  'pages.agent.profile.title': '代理商档案',
  'pages.agent.profile.subtitle': '管理代理商基本信息、合作状态及相关数据',
  'pages.agent.profile.edit': '编辑',

  // 列表
  'pages.agent.profile.column.operation': '操作',
  'pages.agent.profile.column.agentCode': '代理商编码',
  'pages.agent.profile.column.agentName': '代理商名称',
  'pages.agent.profile.column.agentType': '代理商类型',
  'pages.agent.profile.column.contactName': '联系人',
  'pages.agent.profile.column.contactPhone': '联系电话',
  'pages.agent.profile.column.coverageArea': '覆盖区域',
  'pages.agent.profile.column.tenantCount': '租户数',
  'pages.agent.profile.column.deviceCount': '设备数',
  'pages.agent.profile.column.commissionRate': '佣金比例',
  'pages.agent.profile.column.cooperationStatus': '合作状态',
  'pages.agent.profile.column.createTime': '创建时间',

  // 删除/导出
  'pages.agent.profile.deleteSuccess': '删除成功',
  'pages.agent.profile.deleteFailed': '删除失败，请稍后重试',
  'pages.agent.profile.deleteConfirm': '确认删除该代理商？',
  'pages.agent.profile.exportSuccess': '导出成功',
  'pages.agent.profile.exportFailed': '导出失败',
  'pages.agent.profile.export': '导出',
  'pages.agent.profile.exportFileName': '代理商列表',
  'pages.agent.profile.confirm': '确定',

  // 弹窗
  'pages.agent.profile.modal.addTitle': '新增代理商',
  'pages.agent.profile.modal.editTitle': '编辑代理商',
  'pages.agent.profile.modal.subtitle': '请填写代理商基本信息、联系方式和商务配置。*为必填项',
  'pages.agent.profile.modal.cancel': '取消',
  'pages.agent.profile.modal.saveSuccess': '保存成功',
  'pages.agent.profile.modal.addSuccess': '创建成功',

  // 新增/编辑页面
  'pages.agent.profile.page.addTitle': '新增代理商',
  'pages.agent.profile.page.editTitle': '编辑代理商',
  'pages.agent.profile.cancel': '取消',
  'pages.agent.profile.save': '保存',
  'pages.agent.profile.getDetailFailed': '获取代理商详情失败',

  // 表单标签
  'pages.agent.profile.modal.name': '代理商名称',
  'pages.agent.profile.modal.namePlaceholder': '请输入代理商名称',
  'pages.agent.profile.modal.code': '代理商代码',
  'pages.agent.profile.modal.codePlaceholder': '例如：AG-MM-001',
  'pages.agent.profile.modal.type': '代理商类型',
  'pages.agent.profile.modal.typePlaceholder': '请选择代理商类型',
  'pages.agent.profile.modal.area': '覆盖区域',
  'pages.agent.profile.modal.areaPlaceholder': '请输入覆盖区域',
  'pages.agent.profile.modal.contactInfo': '联系方式',
  'pages.agent.profile.modal.contactPerson': '负责人',
  'pages.agent.profile.modal.phone': '联系电话',
  'pages.agent.profile.modal.email': '联系邮箱',
  'pages.agent.profile.modal.tin': 'TIN号码',
  'pages.agent.profile.modal.address': '公司地址',
  'pages.agent.profile.modal.businessConfig': '商务配置',
  'pages.agent.profile.modal.commissionRate': '佣金比例（%）',
  'pages.agent.profile.modal.commissionMode': '佣金模式',
  'pages.agent.profile.modal.commissionModePlaceholder': '请选择佣金模式',
  'pages.agent.profile.modal.settlementCycle': '结算周期',
  'pages.agent.profile.modal.settlementCyclePlaceholder': '请选择结算周期',
  'pages.agent.profile.modal.cooperationStatus': '合作状态',
  'pages.agent.profile.modal.cooperationStatusPlaceholder': '请选择合作状态',
  'pages.agent.profile.modal.startDate': '合作开始日期',
  'pages.agent.profile.modal.endDate': '合同到期日期',
  'pages.agent.profile.modal.otherInfo': '其他信息',
  'pages.agent.profile.modal.remark': '备注',

  // 表单区段
  'pages.agent.profile.section.basicInfo': '基础信息',
  'pages.agent.profile.section.basicInfoAlt': '基本信息',

  // 表单校验
  'pages.agent.profile.form.startDateFormat': '合作开始日期不能大于合作结束日期',
  'pages.agent.profile.form.endDateFormat': '合作结束日期不能小于合作开始日期',

  // 表单通用
  'pages.agent.profile.form.selectPlaceholder': '请选择覆盖区域',
  'pages.agent.profile.form.codeRequired': '请输入代理商编码',
  'pages.agent.profile.form.nameRequired': '请输入代理商名称',
  'pages.agent.profile.form.contactRequired': '请输入联系人姓名',
  'pages.agent.profile.form.phoneRequired': '请输入联系电话',
  'pages.agent.profile.form.phonePlaceholder': '请输入联系电话',
  'pages.agent.profile.form.emailRequired': '请输入邮箱地址',
  'pages.agent.profile.form.emailInvalid': '请输入正确的邮箱地址',
  'pages.agent.profile.form.emailPlaceholder': '请输入邮箱地址',
  'pages.agent.profile.form.addressRequired': '请输入详细地址',
  'pages.agent.profile.form.startDateRequired': '请选择合作开始日期',
  'pages.agent.profile.form.remarkPlaceholder': '请输入备注信息',
  'pages.agent.profile.form.addressPlaceholder': '请输入详细地址',
  'pages.agent.profile.form.tinPlaceholder': '请输入TIN号码',
  'pages.agent.profile.form.commissionPlaceholder': '请输入佣金比例',
  'pages.agent.profile.form.contactPlaceholder': '请输入联系人姓名',

  // 佣金模式选项
  'pages.agent.profile.commissionMode.byDevice': '按设备数',
  'pages.agent.profile.commissionMode.byTenant': '按租户数',
  'pages.agent.profile.commissionMode.byTransaction': '按交易额',

  // 结算周期选项
  'pages.agent.profile.settlementCycle.monthly': '按月结算',
  'pages.agent.profile.settlementCycle.quarterly': '按季结算',
  'pages.agent.profile.settlementCycle.yearly': '按年结算',
};
